module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.isLandscape) ? _c('div', {
    staticClass: "orientation-warning",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "mast"
  }, [(_vm.loaded) ? _c('branding', {
    attrs: {
      "logo": _vm.company.logo.path,
      "altText": _vm.company.company_name,
      "link": _vm.company.url,
      "linkTarget": "_blank"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "intro",
    domProps: {
      "innerHTML": _vm._s(_vm.content.text)
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-156f46b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrientationWarning.vue
// module id = 446
// module chunks = 1